export function ContactField({ label, value, link }) {
  if (!value) return null;
  return (
    <div className="mb-0.5">
      <span className="text-[10px] text-gray-400 uppercase tracking-wider leading-none">{label}</span>
      {link ? (
        <p className="text-[11px] leading-tight truncate"><a href={link} className="text-blue-600 hover:underline" target={link.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer">{value}</a></p>
      ) : (
        <p className="text-[11px] text-gray-900 leading-tight truncate">{value}</p>
      )}
    </div>
  );
}
